/* eslint-disable no-unneeded-ternary */
/* eslint-disable import/no-unresolved */
const lozad = require('lozad');
const searchBase = require('base/search/search');
const constants = require('onestic-base/constants');
const quickShopping = require('../components/quickShopping');

/**
 * Trigger lozad
 */
function triggerLozad() {
    const observer = lozad('.lozad', {
        enableAutoReload: true,
    });
    observer.observe();
}

/**
 * Function to parse search result count information.
 * @param {*} response
 */
function parseSearchCount(response) {
    const searchCount = $('.search-count');
    if (searchCount.length) {
        const msgContent = $(response).find('.search-result-count').length > 0 ? $($(response).find('.search-result-count')[0]) : $(response).find('.search-result-count');
        const msg = msgContent.text();
        const numberContent = $(response).find('.search-keywords').length > 0 ? $($(response).find('.search-keywords')[0]) : $(response).find('.search-keywords');
        const number = numberContent.text();
        searchCount.find('b').html('').append(`${msg} ${number}`);
    }
}

function updateRefinementsViewMoreLink(refinementBar) {
    refinementBar.find('.refinement.active').each((_index, refinement) => {
        const thisTarget = $(refinement);
        const cardBodyHeight = thisTarget.find('.card-body').height() + 5;
        const cardBodyUlHeight = thisTarget.find('.card-body > ul').height();

        if (cardBodyUlHeight > cardBodyHeight) {
            thisTarget.find('.view-more').fadeIn('fast');
        }
    });
}

function showMessage(message, type) {
    let messageIcon;

    if (!$('.add-to-cart-messages').length) {
        $('body').append('<div class="add-to-cart-messages "></div>');
    }

    if (type === 'alert-success') {
        messageIcon = '<span class="icon-checked-line"></span>';
    } else {
        messageIcon = '<span class="icon-alert"></span>';
    }

    $('.add-to-cart-messages').html(`<div class="alert add-to-cart-alert ${type}">${messageIcon} ${message}</div>`);
    $('.decline').trigger('click');
    setTimeout(() => {
        $('.add-to-cart-messages').remove();
    }, 5000);
}

/**
 * Remove the prev/next session variables.
 */
function cleanPrevNextSessionVariables() {
    let enc = false;
    let index = 0;
    while (!enc) {
        const arr = sessionStorage.getItem(`productsPrevNext${index}`);
        if (!arr) {
            enc = true;
        } else {
            sessionStorage.setItem(`productsPrevNext${index}`, '');
            index += 1;
        }
    }
}

function storePrevNext() {
    cleanPrevNextSessionVariables();
    const pageSize = 18;
    const products = $('#productsidsprevnext').val();
    if (products) {
        const arrayProducts = products.split(';');
        const count = arrayProducts.length;
        const possiblePages = Math.round(count / pageSize);

        const numPages = possiblePages > 0 ? possiblePages : 1;

        let init = 0;
        let limit = 0;

        for (let i = 0; i < numPages; i += 1) {
            if (limit !== 0) {
                init = limit + 1;
            }
            limit = (i === (numPages - 1)) ? count - 1 : ((pageSize * (i + 1)));

            const productInit = arrayProducts[init];
            const productFinish = arrayProducts[limit];
            if (productInit && productFinish) {
                const indexInit = products.indexOf(productInit);
                const indexFinish = products.indexOf(productFinish) + productFinish.length;

                const productToStore = products.substring(indexInit, indexFinish);
                sessionStorage.setItem(`productsPrevNext${i}`, productToStore.toString());
            }
        }
        $('#productsidsprevnext').val('');
    }
}

function storeScrollPosition() {
    $('.product-tile').on('click', () => {
        window.localStorage.setItem('scrollY', window.scrollY);
    });
}

function setGridSize(productGrid, localGridSize) {
    if (localGridSize === '4.0') {
        productGrid.removeClass('big-grid medium-grid');
        productGrid.addClass('small-grid');
    } else if (localGridSize === '3.0') {
        productGrid.removeClass('big-grid small-grid');
        productGrid.addClass('medium-grid');
    } else {
        productGrid.removeClass('small-grid medium-grid');
        productGrid.addClass('big-grid');
    }
}

function manageGridSizeIcons($gridSize, localGridSize) {
    $gridSize.find('button').hide();

    if (localGridSize === '4.0' || localGridSize === '3.0') {
        $gridSize.find('.small-grid').show();
    } else {
        $gridSize.find('.big-grid').show();
    }
}

function updateTileImageSrc(localGridSize) {
    const productTileImages = $('.product-tile .image-container img');

    productTileImages.each((index, image) => {
        const tileImage = $(image);
        if (localGridSize === '4.0' || localGridSize === '3.0') {
            tileImage.attr('src', tileImage.attr('data-img-medium'));
            tileImage.attr('data-src', tileImage.attr('data-img-medium'));
            tileImage.attr('data-srcset', `${tileImage.attr('data-img-medium')} 768w, ${tileImage.attr('data-img-medium')} 1920w`);
            tileImage.attr('srcset', `${tileImage.attr('data-img-medium')} 768w, ${tileImage.attr('data-img-medium')} 1920w`);
        } else {
            tileImage.attr('src', tileImage.attr('data-img-small'));
            tileImage.attr('data-src', tileImage.attr('data-img-small'));
            tileImage.attr('data-srcset', `${tileImage.attr('data-img-small')} 768w, ${tileImage.attr('data-img-medium')} 1920w`);
            tileImage.attr('srcset', `${tileImage.attr('data-img-small')} 768w, ${tileImage.attr('data-img-medium')} 1920w`);
        }
    });
}

function updateGridSize() {
    const docBody = $(document.body);
    const productGrid = docBody.find('.product-grid');
    const $gridSize = $('.grid-size');
    const defaultGridSize = $('#gridDefaultCols').val();
    window.localStorage.setItem('grid-size', defaultGridSize);
    let localGridSize = window.localStorage.getItem('grid-size');

   docBody.on('click', '.grid-size button', (e) => {
    const gridSize = $(e.currentTarget).data('size').toString();

    window.localStorage.setItem('grid-size', gridSize);

    manageGridSizeIcons($gridSize, gridSize);
    setGridSize(productGrid, gridSize, true);

    if (window.outerWidth < constants.viewport_bootstrap.lg) {
        updateTileImageSrc(gridSize);
    }
});

    manageGridSizeIcons($gridSize, localGridSize);
    setGridSize(productGrid, localGridSize);
    productGrid.addClass('active');
}

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector, isSort) {
    const $updates = $results.find(selector);
    if (!$updates.length && selector === '.product-grid' && !isSort) {
        const resetLink = $('#categoryResetLink').val();
        $(selector)
            .empty()
            .html(`<p class="text-center w-100 my-5">${$.trim($('#emptyResultsText').val())}</p>`);
        if (resetLink !== null) {
            $('.row.sort-order-wrapper')
                .empty()
                .html(`<a href="#" class="reset" data-href="${resetLink}">${$.trim($('a.reset:eq(0)').text())}</a>`);
        }
    } else {
        const elemToUpdate = $(selector);
        const refinementBar = $('.refinement-bar');
        /* eslint-disable no-lonely-if */
        if (selector === '.product-grid' && isSort) {
            elemToUpdate
                .empty()
                .html($results);
        } else if (selector !== '.permalink') {
            elemToUpdate
                .empty()
                .html($updates.html());
            if (selector === '.active-filters') {
                const resetButton = $('.reset-button-wrapper .btn');
                const totalResultsButton = $('.reset-button-wrapper .show-results');
                const totalResultsCount = $results.find('.result-count').attr('data-products-count');
                const productGrid = $('.product-grid');
                if (elemToUpdate.find('.filter-bar button').length > 0) {
                    resetButton.removeClass('d-none');
                    totalResultsButton.find('.show-results-count').text(totalResultsCount);
                    elemToUpdate.removeClass('d-none');
                    productGrid.addClass('hide-banners');
                } else {
                    resetButton.addClass('d-none');
                    elemToUpdate.addClass('d-none');
                    productGrid.removeClass('hide-banners');
                }
            }
        } else {
            let permalinkValue = elemToUpdate.val();
            if (permalinkValue) {
                if (permalinkValue.indexOf('undefined') !== -1) {
                    const link = permalinkValue.split('?');
                    permalinkValue = link[0].toString();
                    elemToUpdate.val(permalinkValue);
                }
                window.history.pushState(null, null, permalinkValue);
            }
        }

        updateRefinementsViewMoreLink(refinementBar);
    }

    triggerLozad();
    storeScrollPosition();
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    // eslint-disable-next-line func-names
    $('.refinement.active').each(function () {
        $(this).removeClass('active');

        $results.find(`.${$(this)[0].className.replace(/ /g, '.')}`).addClass('active');
    });

    updateDom($results, '.refinements', false);
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    const $results = $(response);
    const specialHandlers = {
        '.refinements': handleRefinements,
    };

    // Update DOM elements that do not require special handling
    [
        '.grid-header',
        '.header-bar',
        '.header.page-title',
        '.active-filters',
        '.permalink',
        '.row.sort-order-wrapper',
        '.product-grid',
        '.category-breadcrumb-fake-filters',
        '.category-breadcrumb-fake-search-banner',
        '.show-more',
    ].forEach((selector) => {
        updateDom($results, selector, false);
    });

    Object.keys(specialHandlers).forEach((selector) => {
        specialHandlers[selector]($results);
    });

    parseSearchCount(response);
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    const $tempDom = $('<div>').append($(response));
    const sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
    sortOptions.forEach((option) => {
        $(`option.${option.id}`).val(option.url);
    });
}

function isInViewport(showMoreBlock) {
    const windowElement = $(window);
    const elementTop = showMoreBlock.offset().top;
    const elementBottom = elementTop + showMoreBlock.outerHeight();

    const viewportTop = windowElement.scrollTop();
    const viewportBottom = viewportTop + windowElement.height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
}

function createCustomPriceRefinement() {
    const priceSliderButton = $('.price-slider-refinement-button');
    const buttonText = $.trim(priceSliderButton.find('> span:not(.checkbox-wrapper)').html());
    const buttonHref = priceSliderButton.attr('data-href');

    const priceRefinementButton = `<button data-href="${buttonHref}" class="btn btn-outline btn-small btn-rounded mr-2 my-1">
            <span>
                ${buttonText}
            </span>
            <span class="icon-cross-line pr-0 pl-1"></span>
        </button>`;

    $('.active-filters .filter-bar').prepend(priceRefinementButton);
}

const countActiveFilters = (response) => {
    const showMoreBlock = $('.show-more');
    const $results = response ? $(response).find('.result-count').attr('data-products-count')
        : showMoreBlock.attr('data-product-count');
    const typeRefinement = $('.refinement > .card-body > ul');
    const spanTotalCount = $('.filter-total-count');
    const excludedFiltersArray = ['refinement-category', 'refinement-categoria', 'refinement-orderby'];
    let totalActiveFilters = 0;
    let activeFilter = 0;
    let activeFilterEnable = 0;

    typeRefinement.each((_index, ul) => {
        const $ul = $(ul);
        const ulParentID = $ul.parent().attr('id');
        const isFilterExcluded = excludedFiltersArray.some(v => ulParentID.includes(v));
        activeFilter = 0;

        if (!isFilterExcluded) {
            $ul
                .find('li')
                .each((_i, li) => {
                    if ($(li).not('.category-attribute').hasClass('checked')) {
                        activeFilter += 1;
                        activeFilterEnable += 1;
                    }
                });
        }

        const parentRefinement = $(ul).parents('.refinement');
        if (activeFilter) {
            totalActiveFilters += activeFilter;

            parentRefinement.addClass('active');
            parentRefinement.find('icon-down-arrow-line').addClass('open');
            parentRefinement
                .find('.total-n-refinement')
                .removeClass('d-none')
                .html(`(${activeFilter})`);
        }
    });

    if (spanTotalCount.length) {
        totalActiveFilters = totalActiveFilters === 0 ? '' : `(${totalActiveFilters})`;
        spanTotalCount.html(totalActiveFilters);
    }

    const refinementsBar = $('.refinement-bar');
    const activeFilters = $('.active-filters');
    const activeFiltersDesktop = $('.products-grid-container .active-filters');
    const resetButton = $('.reset-button-wrapper .btn');
    const totalResultsButton = $('.reset-button-wrapper .show-results');
    if ($('.active-filters .filter-bar > button').length || activeFilterEnable > 0) {
        refinementsBar.addClass('refinement-bar-active-filters');
        activeFilters.removeClass('d-none');
        activeFiltersDesktop.addClass('d-flex');
        resetButton.removeClass('d-none');
        totalResultsButton.find('.show-results-count').text($results);
        if (($('.refinement-price .checked').length || $('.refinement-precio .checked').length) && $('.multi-range').length) {
            createCustomPriceRefinement();
        }
    } else {
        refinementsBar.removeClass('refinement-bar-active-filters');
        activeFilters.addClass('d-none');
        activeFiltersDesktop.removeClass('d-flex');
        resetButton.addClass('d-none');
    }
};

/**
 * Checks refinement status in constants.js and returs bool
 *
 * @param {object} refinement - Element to check
 * @return {status} - Boolean
 */
const checkRefinementStatus = (refinement) => {
    let status = false;
    const refinementsStatusInput = $('#refinementsStatus');
    const refinementsStatusJSON = refinementsStatusInput.length
        && refinementsStatusInput.val() !== undefined
        ? JSON.parse(refinementsStatusInput.val()) : null;
    const refinementID = refinement.attr('data-refinement-id');
    const isCategoryRefinement = refinement.attr('data-is-category-refinement') === 'true' ? true : false;
    const isPriceRefinement = refinement.attr('data-is-price-refinement') === 'true' ? true : false;

    if (refinementsStatusJSON) {
        if (isCategoryRefinement) {
            status = refinementsStatusJSON.category;
        } else if (isPriceRefinement) {
            status = refinementsStatusJSON.price;
        } else if (refinementID in refinementsStatusJSON) {
            status = refinementsStatusJSON[refinementID];
        }
    } else {
        return false;
    }

    return status;
};

/**
 * Show open/close refinements. Values setup in constanst.js plist.refinementsStatus
 */
const showActiveFilters = () => {
    const statusRefinement = $('.refinements > .refinement');

    statusRefinement.each((_index, ul) => {
        const $ul = $(ul);
        const status = checkRefinementStatus($ul);

        if (status) {
            $ul.addClass('active');
        }
    });
};

function replaceUrlParam(url) {
    let paramURL = url;
    if (paramURL.indexOf('https') === -1) {
        paramURL = `${window.location.origin}${url}`;
    }

    const newURL = new URL(paramURL);
    newURL.searchParams.delete('pmin');
    newURL.searchParams.delete('pmax');

    return newURL;
}

const updatePriceFilter = (url, noResults) => {
    const rangeSliderWrapper = $('.multi-range');
    let paramURL = url;

    if (!rangeSliderWrapper) {
        return;
    }

    if (paramURL.indexOf('https') === -1) {
        paramURL = `${window.location.origin}${url}`;
    }

    const newURL = new URL(paramURL);
    let pmin = newURL.searchParams.get('pmin');
    let pmax = newURL.searchParams.get('pmax');

    if (noResults) {
        pmin = window.localStorage.getItem('minPrice');
        pmax = window.localStorage.getItem('maxPrice');
    }

    setTimeout(() => {
        const priceSliderButton = $('.price-slider-refinement-button');
        document.querySelector('#from').textContent = `${pmin}`;
        document.querySelector('#to').textContent = `${pmax}`;
        document.querySelector('#min').value = parseInt(pmin, 10);
        document.querySelector('#max').value = parseInt(pmax, 10);

        const minValue = parseInt(document.querySelector('#min').min, 10);
        const maxValue = parseInt(document.querySelector('#max').max, 10);
        const differenceValue = maxValue - minValue;
        const multiRangeProgressbar = $('.multi-range-bar.after');
        const percentMin = (parseInt(pmin, 10) - minValue) / differenceValue;
        const percentMax = (parseInt(pmax, 10) - minValue) / differenceValue;
        const leftbarPosition = percentMin * 100;
        const rightbarPosition = 100 - (percentMax * 100);
        multiRangeProgressbar.css('left', `${leftbarPosition >= 0 ? leftbarPosition : 0}%`);
        multiRangeProgressbar.css('right', `${rightbarPosition}%`);

        const permalinkURL = $('.permalink').val();
        const updatedURL = replaceUrlParam(permalinkURL);
        priceSliderButton.attr('data-href', updatedURL.href);
        priceSliderButton.find('.pmin').text(pmin);
        priceSliderButton.find('.pmax').text(pmax);
        priceSliderButton.parents('li').addClass('checked');
        priceSliderButton.find('.checkbox-wrapper').addClass('selected');

        window.localStorage.setItem('minPrice', pmin);
        window.localStorage.setItem('maxPrice', pmax);
    }, 300);
};

searchBase.showMore = () => {
    // Show more products
    $('.container').on('click', '.show-more button:not(:disabled)', (e) => {
        e.stopPropagation();
        const showMoreUrl = $(e.currentTarget).attr('data-url');

        e.preventDefault();

        $.spinner().start();
        $(e.currentTarget).trigger('search:showMore', e);
        $.ajax({
            url: showMoreUrl,
            data: { selectedUrl: showMoreUrl },
            method: 'GET',
            success(response) {
                const showMoreButton = $('.show-more button');
                $('.grid-footer').replaceWith(response);

                updateSortOptions(response);
                triggerLozad();
                quickShopping.assignQuickShopping();
                storeScrollPosition();

                if (showMoreButton.length) {
                    showMoreButton.removeAttr('disabled');
                }

                if (window.dataLayer) {
                    $('body').trigger('datalayer:updateGrid');
                }

                $.spinner().stop();

                storePrevNext();
            },
            error() {
                $.spinner().stop();
            },
        });
    });

    if ($('.show-more').attr('data-type') === 'infinite') {
        $(window).on('scroll', () => {
            const showMoreBlock = $('.show-more');
            if (showMoreBlock.length) {
                const showMoreButton = showMoreBlock.find('button');

                if (isInViewport(showMoreBlock) && showMoreButton.length && showMoreButton.hasClass('d-none')) {
                    showMoreButton.trigger('click');
                    showMoreButton.attr('disabled', 'disabled');
                }
            }
        });
    }
};

const processMiniFinder = (arr, thisValue) => {
    arr.each((indx, val) => {
        const refineValue = val;
        const refineButton = $(val).parents('.refinement-button');
        if (refineValue.innerText.toUpperCase().includes(thisValue) || thisValue === '') {
            refineValue.hidden = false;
            refineButton.show();
        } else {
            refineValue.hidden = true;
            refineButton.hide();
        }
    });
};

const miniFinder = () => {
    $('.refinement-bar, .sort-order-wrapper').on('keyup', '.search-fieldDynamic', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const thisTarget = $(e.currentTarget);
        const arr = thisTarget.parents('.card-body').find('.refinement-button > .refinement-button-display-value');
        let thisValue = thisTarget.val().toUpperCase();
        if (e.keyCode === 8) {
            thisValue = thisTarget.val().toUpperCase();
            processMiniFinder(arr, thisValue);
        }
        processMiniFinder(arr, thisValue);
    });
};

searchBase.applyFilter = () => {
    // Handle refinement value selection and reset click
    $('.refinement-bar, .sort-order-wrapper, .filter-container, .active-filters').on(
        'click',
        `.refinements li button:not(.refinement-button-sortby), .search-results .refinements .reset, .filter-value button,
        .swatch-filter button, .filter-tag > button, .reset, .filter-bar > button, .category-name-fake-breadcrumb`,
        (e) => {
            e.preventDefault();
            e.stopPropagation();

            const currentTarget = $(e.currentTarget);
            const linkTarget = currentTarget.attr('data-href');

            $.spinner().start();
            $(this).trigger('search:filter', e);
            const attributeId = `#${currentTarget.find('span').last().attr('id')}`;

            $.ajax({
                url: linkTarget,
                data: {
                    page: $('.grid-footer').attr('data-page-number'),
                    selectedUrl: linkTarget,
                },
                dataType: 'text',
                method: 'GET',
                success(response) {
                    if ($(response).find('.product-grid').length) {
                        parseResults(response);
                        if ($(response).find('.product-grid').length > 0) {
                            const priceRefinementType = $('#priceRefinementType').length ? $('#priceRefinementType').val() : null;
                            if (priceRefinementType && priceRefinementType === 'slider' && (linkTarget.indexOf('pmin') !== -1 || linkTarget.indexOf('pmax') !== -1)) {
                                updatePriceFilter(linkTarget, false);
                            }
                            parseResults(response);
                            setTimeout(() => {
                                countActiveFilters(response);
                            }, 500);
                            triggerLozad();
                            quickShopping.assignQuickShopping();
                            storeScrollPosition();
                            storePrevNext();
                        }
                    } else {
                        const message = $('.refinements').find('.card-body').attr('data-empty-search');
                        if (message) {
                            showMessage(message, 'alert-danger');
                            const priceRefinementType = $('#priceRefinementType').length ? $('#priceRefinementType').val() : null;
                            if (priceRefinementType && priceRefinementType === 'slider' && (linkTarget.indexOf('pmin') !== -1 || linkTarget.indexOf('pmax') !== -1)) {
                                updatePriceFilter(linkTarget, true);
                            }
                        }
                    }
                    $(attributeId).parent('button').focus();
                    $.spinner().stop();
                },
                error() {
                    $(attributeId).parent('button').focus();
                    $.spinner().stop();
                },
            });
        },
    );
};

function updateGridSortBy(target, targetHref) {
    const thisTarget = target;
    const thisValue = targetHref;

    $.spinner().start();
    thisTarget.trigger('search:sort', thisValue);
    $.ajax({
        url: thisValue,
        data: { selectedUrl: thisValue },
        method: 'GET',
        success: (response) => {
            const $results = $(response);
            ['.product-grid'].forEach((selector) => {
                updateDom($results, selector, true);
            });

            triggerLozad();
            quickShopping.assignQuickShopping();
            storeScrollPosition();
            $.spinner().stop();
            storePrevNext();
        },
        error: () => {
            $.spinner().stop();
        },
    });
}

searchBase.sort = () => {
    const searchResultsWrapper = $('.search-results');
    // Handle sort order menu selection
    searchResultsWrapper.on('change', '[name=sort-order]', (e) => {
        e.preventDefault();
        const thisTarget = $(e.currentTarget);
        const thisValue = thisTarget.val();
        updateGridSortBy(thisTarget, thisValue);
    });

    searchResultsWrapper.on('click', '.refinement-button-sortby', (e) => {
        e.preventDefault();
        const thisTarget = $(e.currentTarget);
        const thisValue = thisTarget.attr('data-href');
        updateGridSortBy(thisTarget, thisValue);
    });
};


module.exports = {
    ...searchBase,

    storeScrollPosition,

    updateGridSize,

    storePrevNext,

    miniFinder,

    resize: () => {
        // Remove CORE behaviour
    },

    checkBannerImageExists: () => {
        if ($('.search-banner-image').length && $('#headerTransparency').val()) {
            $('#Search-Show').addClass('header-transparency');
        }
    },

    customNavHorizontalScroll() {
        const categoryNavWrapper = $('.category-navigation-wrapper');
        if (categoryNavWrapper.length) {
            categoryNavWrapper.on('wheel', (e) => {
                e.preventDefault();
                const thisTarget = $(e.currentTarget);
                thisTarget.scrollLeft(thisTarget.scrollLeft() + e.originalEvent.deltaY);
            });
        }
    },

    refinementEvents() {
        const docBody = $(document.body);

        showActiveFilters();
        countActiveFilters(null);

        docBody.on('click', '.refinement .card-header', (e) => {
            const thisTarget = $(e.currentTarget);
            const cardBody = `#${thisTarget.attr('data-body')}`;
            const parentCard = thisTarget.parents('.refinement');

            $(cardBody).slideToggle('fast');
            parentCard.toggleClass('active');
            thisTarget.find('.icon-down-arrow-line').toggleClass('open');

            if (!parentCard.hasClass('active')) {
                parentCard.find('.view-more').fadeOut('fast');
            }

            setTimeout(() => {
                const cardBodyHeight = parentCard.find('.card-body').height() + 5; // +5 para compensar flotado elementos y padding
                const cardBodyUlHeight = parentCard.find('.card-body > ul').height();

                if (cardBodyUlHeight > cardBodyHeight && parentCard.hasClass('active')) {
                    parentCard.find('.view-more').fadeIn('fast');
                }
            }, 500);
        });

        docBody.on('click', '.refinement .view-more', (e) => {
            e.preventDefault();
            const thisTarget = $(e.currentTarget);
            const cardBody = `#${thisTarget.attr('data-refinement')}`;
            thisTarget.toggleClass('open');
            $(cardBody).toggleClass('open');
        });

        docBody.on('click', '.show-more-less-description div', (e) => {
            e.preventDefault();
            const thisTarget = $(e.currentTarget);
            const descBlock = $('.description-block .block-description');

            if (descBlock.length) {
                thisTarget.parents('.show-more-less-description').toggleClass('open');
                descBlock.toggleClass('open');
            }
        });

        const refinementBar = $('.refinement-bar');
        const header = $('header');
        const menuMobileToggler = $('#menuMobileToggler');
        const filterResetButton = $('.reset-button-wrapper');
        const isClosablePanel = bar => bar && !$(bar).hasClass('visible');

        if (isClosablePanel(refinementBar[0]) && !refinementBar.hasClass('open')) {
            refinementBar.attr('inert', '');
        }

        const FILTER_FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), '
            + 'select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
        let filterOpener = null;
        let activeBar = null;

        const getFilterFocusable = () => (activeBar
            ? $(activeBar).find(FILTER_FOCUSABLE).filter(':visible')
            : $());

        const onFilterTrapKeydown = (e) => {
            if (e.key === 'Escape') {
                e.preventDefault();
                $('.mobile-filters-heading .icon-cross-line').trigger('click');
                return;
            }
            if (e.key !== 'Tab') {
                return;
            }
            const focusable = getFilterFocusable();
            if (!focusable.length) {
                return;
            }
            const first = focusable[0];
            const last = focusable[focusable.length - 1];
            const active = document.activeElement;
            if (e.shiftKey && active === first) {
                e.preventDefault();
                last.focus();
            } else if (!e.shiftKey && active === last) {
                e.preventDefault();
                first.focus();
            }
        };

        const onFilterFocusGuard = (e) => {
            if (!activeBar || activeBar.contains(e.target)) {
                return;
            }
            const focusable = getFilterFocusable();
            if (focusable.length) {
                focusable[0].focus();
            }
        };

        const openFilterTrap = () => {
            activeBar = $('.refinement-bar.open')[0] || refinementBar[0];
            if (!activeBar) {
                return;
            }
            $(activeBar).removeAttr('inert');
            filterOpener = document.activeElement;
            $(activeBar).attr({ role: 'dialog', 'aria-modal': 'true' });
            docBody.on('keydown.filtersTrap', onFilterTrapKeydown);
            document.addEventListener('focusin', onFilterFocusGuard, true);

            const target = getFilterFocusable()[0];
            if (target) {
                target.focus();
            }
        };

        const closeFilterTrap = () => {
            docBody.off('keydown.filtersTrap');
            document.removeEventListener('focusin', onFilterFocusGuard, true);
            const bar = activeBar;
            activeBar = null;
            if (bar) {
                $(bar).removeAttr('role').removeAttr('aria-modal');
            }
            if (filterOpener && typeof filterOpener.focus === 'function') {
                filterOpener.focus();
            }
            filterOpener = null;
            if (isClosablePanel(bar)) {
                $(bar).attr('inert', '');
            }
        };

        docBody.on('click', '.mobile-filters-heading .icon-cross-line', (e) => {
            e.preventDefault();
            refinementBar.removeClass('open');
            header.css('z-index', 4);
            // change for iphone / safari devices
            filterResetButton.addClass('d-none');
            closeFilterTrap();
        });

        docBody.on('click', '.search-results .filter-results', (e) => {
            e.preventDefault();
            refinementBar.toggleClass('open');
            // change for iphone / safari devices
            filterResetButton.toggleClass('d-none');

            if (refinementBar.hasClass('open')) {
                updateRefinementsViewMoreLink(refinementBar);
                // change for iphone / safari devices
                filterResetButton.removeClass('d-none');
                openFilterTrap();
            } else {
                closeFilterTrap();
            }

            const headerZindex = window.outerWidth < constants.viewport_bootstrap.lg
                && menuMobileToggler.css('display') !== 'none'
                && refinementBar.hasClass('open') ? 1 : 4;
            header.css('z-index', headerZindex);
        });

        docBody.on('click', '.show-results', (e) => {
            e.preventDefault();
            $('.mobile-filters-heading .icon-cross-line').trigger('click');
        });
    },

    searchShowHeading() {
        const paramValueField = $('#queryParamsValue').val();
        const searchBannerHeading = $('.search-banner .text-block .title');
        if (paramValueField && paramValueField !== '' && paramValueField !== 'undefined') {
            const searchBannerPrefix = searchBannerHeading.attr('data-collection');
            if (searchBannerPrefix && searchBannerPrefix !== undefined && searchBannerPrefix !== 'undefined') {
                searchBannerHeading.text(`${searchBannerPrefix} ${paramValueField}`);
            }
        }
        searchBannerHeading.css('opacity', 1);
    },
};
